<template>
  <div class="party-wrap">
    <!-- 大党委标题 -->
    <header class="party-header">
      <img
        class="party-header_img"
        src="@/assets/images/partyDetail/flag.png"
        :title="party.zoneName"
      />
      <div class="party-header_title">{{party.zoneName}}</div>
    </header>
    <!-- 成员数 -->
    <section class="user-count">
      <img class="user-count_img" src="@/assets/images/partyDetail/peopleNumber.png" title="成员数" />
      成员数：
      <span class="user-count_number">{{personList.length}}</span>
      <span class="user-count_unit">人</span>
    </section>

    <!-- 人员列表 -->
    <section class="ldb-list-wrap">
      <div class="ldb-list">
        <bk-person
          class="ldb-list_item"
          v-for="item in personList"
          :key="item.id"
          :user="item"
          @on-edit="onPersonEdit(item)"
          @on-delete="onPersonDelete(item)"
        ></bk-person>
      </div>
      <img
        v-if="!personList.length"
        class="no-person_img"
        src="@/assets/images/partyDetail/no-person.png"
        title="暂无数据"
      />
      <Button class="party-btn" type="warning" @click="onAdd">添加</Button>
    </section>

    <!-- 添加 / 编辑人员弹窗 -->
    <!-- 类似 autocomplete-on-select 事件 主要为了内部组件通信 -->
    <form-modal
      :modal="ldb_Modal"
      :form-option="ldb_option"
      @on-ok="onConfirm"
      @autocomplete-on-select="onAutoCompleteSelect"
      @select-on-change="onSelectChange"
    ></form-modal>
  </div>
</template>

<script>
import formModal from "@/components/form-modal";
import bkPerson from "./components/person";

function getOption({
  context,
  type = {
    id: ""
  },
  autoComplete = {
    value: "",
    disabled: false
  },
  avatar = {
    src: ""
  },
  job = {
    value: "",
    disabled: false,
    data: []
  },
  phone = {
    value: ""
  },
  title = {
    value: ""
  },
  originData=[]
}) {
  return [
    {
      type: "select",
      name: "job",
      title: "职务",
      labelInValue: true,
      value: job.value,
      data: job.data,
      disabled: job.disabled
    },
    {
      type: "auto-complete",
      title: "姓名",
      name: "name",
      value: autoComplete.value,
      disabled: autoComplete.disabled,
      url: context.urlobj.partyList4add,
      originData:originData,
      params: {
        zoneId: context.partyId,
        typeId: type.id,
        userName: "",
        valueRelated: "userName" // 将value赋值到该字段指向的属性
      }
    },
    {
      type: "avatar",
      name: "avatar",
      title: "头像",
      src: avatar.src
    },
    {
      type: "input",
      name: "phone",
      title: "工作电话",
      inputType: "tel",
      value: phone.value
    },
    {
      type: "input",
      name: "title",
      title: "职称",
      value: title.value,
    },
  ];
}

export default {
  name: "ldb",
  components: { formModal, bkPerson },
  props: {},
  data() {
    return {
      party: {},
      personList: [],
      ldb_Modal: {
        value: false,
        title: "添加"
      },
      ldb_option: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    /* 获取详情 */
    getDetail() {
      let url = this.urlobj.getPartyDetail(this.partyId);
      this.$showLoading();
      this.$get(url)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.party = res.rows[0];
          // 如果有人员 取出人员 不区分类别
          if (!this._.isEmpty(res.rows[0].userMapList)) {
            let tmp = res.rows[0].userMapList;

            let tmpArr = [];
            for (let key of Object.keys(tmp)) {
              tmpArr.push(...tmp[key]);
            }
            this.personList = tmpArr;
          } else {
            this.personList = [];
          }
        })
        .finally(this.$hideLoading);
    },
    /* 查询页面字典表 */
    initDic() {
      // 查询参数对应的字典表
      let url = this.urlobj.dictionaryList("2deputy_1member_job");
      this.$get(url).then(res => {
        if (!res.isSucceed) return this.$Message.error(res.message);
        this.jobData = res.rows.map(item => {
          return {
            label: item.dicName,
            value: item.id
          };
        });
      });
    },
    /* 添加人员 */
    onAdd() {
      this.ldb_Modal = {
        value: true,
        title: "添加"
      };
      this.ldb_option = getOption({
        context: this,
        job: {
          value: "",
          data: this.jobData
        }
      });
    },
    /* 确定添加人员 */
    onConfirm(formOption) {
      let user = formOption.get("name"),
        userOrigin = user.originData[0], // 取用户校验用的值
        userValue = user.value, // 取用户校验用的值
        avatar = formOption.get("avatar"),
        title = formOption.get("title"),
        phone = formOption.get("phone"),
        job = formOption.get("job");
      if (user.disabled) {
        userOrigin = this.editPerson;
      }
     
      //if (!user.disabled) {
        // 选取的用户姓名不能编辑 校验
        // if (!userOrigin) return this.$Message.warning("用户姓名不存在");

        // if (user.value !== userOrigin.userName)
        //   return this.$Message.warning("用户不在选择列表");
      //}

      let url = this.urlobj.partyUser;
      let data = {
        zoneId: this.partyId,
        typeId: user.params.typeId,
        //unionId: userOrigin.unionId,
        //userName: userOrigin.userName,
        userName: userValue,
        headPicUrl: avatar.src,
        phoneNO: phone.value,
        proTitle: title.value,
        // proTitle: this.selectedEvent.label
      };
      // 修改人员 添加参数
      if (user.disabled) {
        data.id = userOrigin.id;
      }
      if(userOrigin) {
        data.unionId =  userOrigin.unionId,
        data.userName = userOrigin.userName
      }
      this.$showLoading();
      this.$post(url, data)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.$Message.success("添加成功");
          this.getDetail();

          // 更新list 页面视图
            this.$bus.$emit("miniParty_personChange");
        })
        .finally(this.$hideLoading);
    },
    /* 自动补全 选择 */
    onAutoCompleteSelect(selected, disabled = false) {
      this.ldb_option = getOption({
        context: this,
        type: {
          id: this.selectedEvent.value
        },
        job: {
          value: this.selectedEvent.value,
          data: this.jobData,
          disabled
        },
        autoComplete: {
          value: selected.userName,
          disabled
        },
        avatar: {
          src: selected.headPicUrl
        },
        phone: {
          value: selected.phoneNO
        },
        title: {
          value: selected.proTitle
        },
        originData:[selected]
      });
    },
    /* 下拉选择 */
    onSelectChange(event) {
      // 重置组件时会触发下拉改变
      if (!event) return;
      this.selectedEvent = event;
      // 重置组件
      this.ldb_option = getOption({
        context: this,
        type: {
          id: event.value
        },
        job: {
          value: event.value,
          data: this.jobData
        }
      });
    },
    /* 人员编辑 */
    onPersonEdit(person) {
      this.ldb_Modal = {
        value: true,
        title: "编辑"
      };
      // 存储当前人员
      this.editPerson = person
      // 查找人员职位信息
      for (let item of this.jobData) {
        if (person.typeName === item.label) {
          this.selectedEvent = item;
          break;
        }
      }
      this.onAutoCompleteSelect(person, true);
    },
    /* 人员删除弹窗 */
    onPersonDelete(person) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确认要进行删除操作吗？</p>",
        onOk: () => {
          // 执行删除操作
          let url = this.urlobj.partyUserDelete(person.id);
          this.$delete(url).then(res => {
            if (!res.isSucceed) return this.$Message.error(res.message);
            this.$Message.success("删除成功");
            this.getDetail(); // 刷新页面

            // 更新list 页面视图
            this.$bus.$emit("miniParty_personChange");
          });
        }
      });
    }
  },
  created() {},
  mounted() {
    this.partyId = this.$route.query.id; // 支部id
    this.orgId = this.$route.query.orgId; // 社区id
    this.getDetail();
    // 初始化字典表
    this.initDic();
  }
};
</script>
<style lang="less" scoped>
@marginGap: 0.2rem;
@adderessFontSize: 0.24rem;

.party-wrap {
  .flex(center, @flexDirection:column);
}
/* 头部 */
.party-header {
  .flex(center);
  margin: @marginGap 0;
}
.party-header_img {
  height: 0.7rem;
  width: 0.7rem;
  margin-bottom: -@marginGap;
}
.party-header_title {
  font-family: "KaiTi";
  font-size: 0.48rem;
  font-weight: 600;
  color: transparent;
  background: url("~@/assets/images/partyDetail/orgTitleBg.jpg");
  background-repeat: repeat-x;
  background-clip: text;
  -webkit-background-clip: text;
  white-space: nowrap;
}
.user-count {
  .flex(center);
  font-size: 22px;
  color: #ff4200;
  line-height: 1;
}
.user-count_img {
  width: 22px;
  height: auto;
}
.user-count_number {
  font-size: 26px;
}
.user-count_unit {
  align-self: flex-end;
  font-size: 14px;
}

.ldb-list-wrap {
  .flex(center, @flexDirection:column);
  margin-top: 0.5rem;
}
.ldb-list {
  .flex(flex-start, @flexWrap:wrap);
  &_item {
    margin: 0.2rem;
  }
}
/* 按钮和占位图 */
.party-btn {
  padding: 8px 0.3rem;
  font-size: 0.26rem;
  line-height: 1;
  margin-top: @marginGap;
}
.no-person_img {
  width: 3rem;
  height: auto;
}
</style>